/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import resetPasswordFormData from "./data/ResetPasswordForm.data";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import ToastService from "../../services/toastService/ToastService";
import { useResetPasswordForWebMemberMutation } from "../../app/services/GMAP/login";

const ResetPasswordForm = () => {
  const formRef = useRef();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [resetPassword, { isLoading, isSuccess, data: apiData, isError, error }] = useResetPasswordForWebMemberMutation();

  const token = searchParams.get("token") || searchParams.get("Token");
  const emailAddress = searchParams.get("emailAddress") || searchParams.get("email");
  const memberId = searchParams.get("memberId") || searchParams.get("id");

  useEffect(() => {
    if (!isLoading && isSuccess) {
      if (apiData === false || (apiData && apiData.isSuccess === false)) {
        ToastService.error(apiData.message || "Failed to reset password. Please try again.");
      } else {
        ToastService.success("Password has been reset successfully.", "Success");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      }
    }
  }, [isLoading, isSuccess, apiData]);

  useEffect(() => {
    if (isError && error) {
      ToastService.error(error?.data?.message || "An error occurred. Please try again.");
    }
  }, [isError, error]);

  const handleResetPassword = () => {
    const formData = formRef.current?.getFormData();
    if (!formData) return;

    if (!token) {
      ToastService.error("Reset token is missing from URL.");
      return;
    }

    const request = {
      password: formData.password,
      confirmPassword: formData.confirmPassword,
      token: token,
      emailAddress: emailAddress,
      memberId: memberId,
    };

    resetPassword(request);
  };

  return (
    <div className="login-form-section">
      <FormCreator
        ref={formRef}
        {...resetPasswordFormData}
      />
      <div className="button-part">
        <Buttons
          buttonTypeClassName="btn success-btn"
          buttonText="Continue"
          onClick={handleResetPassword}
          isLoading={isLoading}
        />
      </div>
      <div className="back-to-login" style={{ textAlign: "center", marginTop: "15px" }}>
        <Link to="/login" className="font-medium text-[#329a03] hover:text-[#297407]" style={{ fontSize: "14px", fontWeight: "600" }}>
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
